import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'servicedesk-insight-attribute-views.user.placeholder',
		defaultMessage: 'No users selected',
		description: 'Message displayed when there are no users selected for an attribute',
	},
});
